import isEqual from 'lodash.isequal';

export default class ErrorHelper {

  static scrollOnError = (props, prevProps, namespaces) => {
    let error, prevError;
    namespaces.forEach(namespace => {
      if(props[namespace]) {
        error = Object.assign({}, props[namespace]);
      }

      if(prevProps[namespace]) {
        prevError = Object.assign({}, prevProps[namespace]);
      }
    });

    if (error && !isEqual(error, prevError)) {
      window.scrollTo(0, 0);
    }
  }

  static getValidationErrorClass(field, errors, isTouched) {
    if(!errors) return ""

    if(errors.errorKeys && errors.errorKeys[field] && !isTouched) {
      return "is-invalid";
    }

    return "";
  }

  static getValidationErrorClassForStorySection(sectionId, field, errors) {
    if(!errors) return "";

    const hasErrors = errors.errorKeys && errors.errorKeys[sectionId];
    const errorClass = "is-invalid";

    if(hasErrors && field === "any") {
      return errorClass;
    }

    if(hasErrors && (errors.errorKeys[sectionId][field] || (typeof errors.errorKeys[sectionId] === "string" && field === "image"))) {
      return "is-invalid";
    }

    return "";
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorHelper.js